import {
    KNOWLEDGE_ITEM_RESPONSE,
    MODERATION_FEED_ITEM_RESPONSE,
    UNAUTHENTICATED,
    KNOWLEDGE_ITEM_SAVE_RESPONSE,
    MODERATION_FEED_ITEM_SAVE_RESPONSE,
    CLUSTER_ITEM_RESPONSE
} from "../../actions/action-types"
import { toUI } from "../../models/entities/concept"
import { extractEntitiesFromData } from "./entity-reducer-utils"

export default (state = {}, action) => {
    const { type, data } = action
    switch (type) {
        case KNOWLEDGE_ITEM_SAVE_RESPONSE:
        case KNOWLEDGE_ITEM_RESPONSE:
        case MODERATION_FEED_ITEM_SAVE_RESPONSE:
        case MODERATION_FEED_ITEM_RESPONSE:
            return extractEntitiesFromData(data.concepts, state, false, toUI)
        case CLUSTER_ITEM_RESPONSE:
            return extractEntitiesFromData(data.concepts, state)
        case UNAUTHENTICATED:
            return {}
        default:
            return state
    }
}
